class StatusController {
  constructor() {
    this.model = undefined;
    this.statuses = {
      Off: 'Off',
      On: 'On'
    };
  }

  $onChanges(changes) {
    if (changes) {
      if (changes.series) {
        this.model = changes.series;
      }
      if (changes.off) {
        this.status = this.off ? this.statuses.Off : this.statuses.On;
      }
    }
  }
}

export default {
  template: require('./status.html'),
  restrict: 'E',
  controller: StatusController,
  controllerAs: 'vm',
  bindings: {
    series: '<',
    off: '<'
  }
};
